import { SearchInput } from './styles';

export default function SearchBar({ value, onInputChange }) {
  return (
    <SearchInput
      value={value}
      placeholder='Search on card name and number..'
      onChange={onInputChange}
    />
  );
}
